<script lang="ts">
    import {version} from '$app/environment';
    import {constants} from '$lib/stores/constants';
</script>

<footer class="py-4 bg-black-50">
    <div class="container flex flex-col px-4 gap-y-4 lg:flex-row lg:justify-between">
        <nav>
            <ul class="flex flex-col sm:flex-row gap-x-8 gap-y-4">
                <li>
                    <a class="text-black-500" href="/agreement">Пользовательское соглашение</a>
                </li>

                <li>
                    <a href="mailto:support@q-parser.ru">support@q-parser.ru</a>
                </li>
            </ul>
        </nav>

        <div class="flex gap-4 fill-black-500">
            {#if $constants.social.vk}
                <a href={$constants.social.vk.url} rel="nofollow" target="_blank" title="Q-Parser во ВКонтакте">
                    <svg height="25" viewBox="0 0 24 24" width="25" xmlns="http://www.w3.org/2000/svg">
                        <path
                            class="svg-icon"
                            d="M17.9 16h-1.7s-.4 0-.8-.2c-.6-.4-1.2-1.5-1.7-1.4-.5.1-.4 1.1-.4 1.1s0 .2-.1.3c-.2.2-.5.2-.5.2h-.8s-1.7.1-3.2-1.4C7 13 5.5 9.8 5.5 9.8s-.1-.2 0-.3c.1-.1.4-.1.4-.1h1.9s.2 0 .3.1c.1.1.1.2.1.2s.4.6.8 1.3c.8 1.3 1.1 1.5 1.4 1.4.4-.2.2-1.8.2-1.8s0-.6-.2-.8c-.1-.2-.4-.3-.6-.3-.1 0 0-.2.3-.3.4-.2 1-.2 1.7-.2.5 0 .7 0 .9.1.6.1.4.7.4 2.1 0 .4-.1 1 .2 1.3.1.1.5 0 1.3-1.4.4-.7.7-1.4.7-1.4s0-.1.1-.2h2.1s.6 0 .7.2c.1.3-.2.9-1 1.9-1.3 1.6-1.4 1.5-.3 2.4 1 .9 1.2 1.4 1.3 1.4.6.6-.3.6-.3.6z"
                        />
                        <path
                            class="svg-icon"
                            d="M20 2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16m0-2H4C1.8 0 0 1.8 0 4v16c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4z"
                            fill-rule="evenodd"
                        />
                    </svg>
                </a>
            {/if}

            {#if $constants.social.ok}
                <a href={$constants.social.ok.url} rel="nofollow" target="_blank" title="Q-Parser в Одноклассниках">
                    <svg height="25" viewBox="0 0 27 27" width="25" xmlns="http://www.w3.org/2000/svg">
                        <path
                            class="stroke-black-500"
                            d="M5 1h16c2.209 0 4 1.79 4 4v16c0 2.209-1.791 3.999-4 3.999H5c-2.209 0-4-1.79-4-3.999V5c0-2.21 1.791-4 4-4z"
                            fill="none"
                            stroke-width="2"
                        />
                        <path
                            class="svg-icon"
                            d="M16.809 13.55c-.89 1.009-2.009 1.562-3.186 1.725l2.038 2.311c.287.293.287.813 0 1.139-.144.163-.345.228-.517.228-.201 0-.373-.065-.516-.228l-1.637-1.855-1.636 1.855c-.259.326-.718.326-1.005 0-.287-.293-.287-.814 0-1.139l2.038-2.311c-1.148-.13-2.296-.716-3.186-1.725-.287-.293-.259-.814 0-1.139.258-.325.717-.325 1.004 0 1.551 1.757 4.048 1.757 5.599 0 .258-.325.717-.325 1.004 0 .259.325.259.846 0 1.139zm-3.818-1.543c-1.648 0-2.996-1.351-2.996-3.004s1.348-3.005 2.996-3.005c1.647 0 2.995 1.352 2.995 3.005 0 1.653-1.348 3.004-2.995 3.004zm0-4.506c-.839 0-1.498.661-1.498 1.502s.659 1.503 1.498 1.503 1.498-.662 1.498-1.503c0-.841-.659-1.502-1.498-1.502z"
                            fill-rule="evenodd"
                        />
                    </svg>
                </a>
            {/if}

            {#if $constants.social.youtube}
                <a href={$constants.social.youtube.url} rel="nofollow" target="_blank" title="Q-Parser на YouTube">
                    <svg height="25" viewBox="0 0 27 27" width="25" xmlns="http://www.w3.org/2000/svg">
                        <path
                            class="stroke-black-500"
                            d="M5 1h16c2.209 0 4 1.79 4 4v16c0 2.209-1.791 3.999-4 3.999H5c-2.209 0-4-1.79-4-3.999V5c0-2.21 1.791-4 4-4z"
                            fill="none"
                            stroke-width="2"
                        />
                        <path
                            class="svg-icon"
                            d="M11 15.615V9.423c0-.287.291-.501.578-.333.231.135 4.838 2.856 5.232 3.089.258.153.253.517 0 .67-.284.172-4.908 2.907-5.243 3.097-.246.139-.567-.014-.567-.331z"
                            fill-rule="evenodd"
                        />
                    </svg>
                </a>
            {/if}
        </div>

        <div class="text-black-500">
            2018-{new Date().getFullYear()} &copy; Q-Parser. Все права защищены. {version}
        </div>
    </div>
</footer>
